import { Close } from '@mui/icons-material'

import { Heading3 } from '../../../data-display/typography/Typography'
import { IconButton } from '../../../inputs/icon-button'

import { StyledDialogTitle } from './DialogTitle.styled'

export interface DialogTitleProps {
  children: string
  onClose?: () => void
}

export const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props

  return (
    <StyledDialogTitle {...other}>
      <Heading3 component="span">{children}</Heading3>
      {onClose && (
        <IconButton ariaLabel="close" onClick={onClose} edge="end" size="small">
          <Close />
        </IconButton>
      )}
    </StyledDialogTitle>
  )
}
